import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import Loading from '../../common/Loading'
import { getRoleColumns } from './RoleFields'
import { useMemo } from 'react'

const ListRoles = () => {
  const { user } = useAuth()
  const userRight = useOutletContext()
  const columns = useMemo(() => getRoleColumns(), [])

  const options = useMemo(
    () => ({
      objectType: 'roles',
      accessRight: userRight,
      objectFilter: () => ({ company_id: user.company_id }),
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer le rôle',
          field: 'name'
        }
      },
      isExpand: false,
      isFilter: true,
      columns
    }),
    [userRight, user.company_id, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'roles',
      title: 'Rôles',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, columns]
  )

  if (!columns.length) return <Loading />
  return <ListModule options={options} toolbar={toolbar} />
}

export default ListRoles
